import { render, staticRenderFns } from "./AppReviewableForm.vue?vue&type=template&id=ecd73266&scoped=true&"
import script from "./AppReviewableForm.vue?vue&type=script&lang=js&"
export * from "./AppReviewableForm.vue?vue&type=script&lang=js&"
import style0 from "./AppReviewableForm.vue?vue&type=style&index=0&id=ecd73266&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd73266",
  null
  
)

export default component.exports